export default function rgbToRgba(rgb: string, alpha: number) {

    if (!rgb.startsWith("rgb(")) {
        return rgb;
    }

    return rgb.replace("rgb(", "rgba(").replace(")", `, ${alpha.toFixed(2)})`);
}